import { CriteriaConfig, LogCriteria, LogFilterType } from '../../../../dtos/search-criteria.dto';
import { AlertBlockAction, getEnumOptions, TimeRange } from '../../../../utils/enums';
import { maxLength } from '../../../../utils/validationUtils';
import { checkSingleIp } from '../../../../utils/ipValidationUtil';

export const urlFilteringCriteriaConfig: CriteriaConfig<LogCriteria>[] = [
    {
        accessor: 'timeDetails',
        header: 'Time',
        type: LogFilterType.TIME,
        defaultValue: TimeRange.LAST_24_HOURS,
        options: getEnumOptions(TimeRange),
        width: 305,
        allowedDaysAgo: 39
    },
    {
        accessor: 'url',
        header: 'URL',
        type: LogFilterType.INPUT,
        defaultValue: 'www.someaddress.com',
        width: 240,
        validationRules: [maxLength(2048)]
    },
    {
        accessor: 'sourceIp',
        header: 'Source IP',
        type: LogFilterType.INPUT,
        defaultValue: '',
        width: 140,
        validationRules: [checkSingleIp]
    },
    {
        accessor: 'destIp',
        header: 'Destination IP',
        type: LogFilterType.INPUT,
        defaultValue: '',
        width: 140,
        validationRules: [checkSingleIp]
    },
    {
        accessor: 'action',
        header: 'Action',
        type: LogFilterType.DROP_DOWN,
        options: getEnumOptions(AlertBlockAction).map(option => option.label === AlertBlockAction.BLOCK ?
            { label: 'Block', value: AlertBlockAction.BLOCK } : option),
        defaultValue: AlertBlockAction.ALL,
        width: 100
    }
];
